import * as React from 'react'

import { selectCompanyHeaderDisplaySettings } from '@user/store/companyHeaderDisplaySettings/slice'
import { selectCompanyInfo } from '@user/store/companySetup/slice'
import { useAppSelector } from '@user/store/hooks/useAppSelector'

import { buildCompanyIdentifier } from '../buildCompanyIdentifier'
import { ICompanyIdentifier } from '../typings'

/**
 * Derives the company identifier (name and full string) from the display
 * settings and `/company` data in the store. Null means nothing should render:
 * no enabled fields, blank values, still loading, or a failed fetch.
 */
export const useCompanyIdentifier = (): ICompanyIdentifier | null => {
  const settings = useAppSelector(selectCompanyHeaderDisplaySettings)
  const company = useAppSelector(selectCompanyInfo)

  return React.useMemo(
    () => buildCompanyIdentifier(settings, company),
    [settings, company],
  )
}
